import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { CORE_QUERY_KEYS } from 'app/hooks/data/core/admin/hotels';
import { hotelPath } from 'app/hooks/data/hotels/useHotel';
import type { FinanceForm } from 'app/typings/hotels/Finance/Finance';
import { apiMutation } from 'app/utils/request/api';

const saveHotelFinancePath = 'hotels/:hotelId/finance' as const;

export function useSaveHotelFinance(hotelId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: FinanceForm) =>
      apiMutation(
        'PUT',
        {
          path: saveHotelFinancePath,
          params: { hotelId },
        },
        payload
      ) as Promise<void>,
    onSuccess: () => {
      message.success('Hotel successfully saved!');
      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.hotelInfo],
      });
      queryClient.invalidateQueries({ queryKey: [hotelPath] });
    },
    onError: () => {
      message.error('Error posting services');
    },
  });
}
